<template>
    <Page header="Клиенты" type="" :nopadding="false" header_pos="left">
        <template #body>
            <div v-if="!loading && clients" class="w-full flex flex-column gap-2">
                <div class="flex gap-2">
                    <Button @click="LoadClients" :disabled="loading" 
                        label="Обновить" icon="pi pi-refresh" severity="secondary" size="small" class="flex"/>
                    <Button label="Сбросить" icon="pi pi-times" @click="resetFilters" severity="secondary" size="small" class="flex"/>
                </div>
                <AdminClientList 
                    :clients="clients" 
                    :users="users"
                    :totalRecords="totalRecords" 
                    :loading="loading" 
                    :filters="lazyParams.filters"
                    :defaultParams="lazyParams"
                    @filter="setFilter" 
                    @lazyParams="setParams" />
            </div>
            <Skeleton v-else width="100%" height="30px" />
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import AdminClientList from '@/components/admin/client_list.vue'
import Page from '@/components/public/page.vue'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'

export default {
    data() {
        return {
            loading: false,
            clients: null,
            users: null,        // TODO: перенести в store
            lazyParams: {
                rows: 10,
                first: 0,
                sortField: null,
                sortOrder: null,
                sort: null,
                filters: {},
            },
            filters: {
                id: {value: '', matchMode: 'contains'}, 
                user_id: {value: '', matchMode: 'contains'},
                project_id: {value: '', matchMode: 'contains'},
                email: {value: '', matchMode: 'contains'},
                fullname: {value: '', matchMode: 'contains'},
                created_at: { 
                    operator: FilterOperator.AND, 
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] 
                },
            },
        }
    },
    components: {
        AdminClientList,
        Page
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.LoadClients()
        },
        setParams(params) {
            this.lazyParams = params
            this.LoadClients()
        },
        onPage(event) {
            this.lazyParams = event
        },
        resetFilters() {
            this.filters = {
                id: {value: '', matchMode: 'contains'}, 
                user_id: {value: '', matchMode: 'contains'},
                project_id: {value: '', matchMode: 'contains'},
                email: {value: '', matchMode: 'contains'},
                fullname: {value: '', matchMode: 'contains'},
                created_at: { 
                    operator: FilterOperator.AND, 
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] 
                },
            }
            this.lazyParams.filters = this.filters
            this.LoadClients()
        },
        async LoadClients() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' })
            const account_data = await this.connect.GetAdminClients(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, {}).then(res=>res)
            if(account_data.result) {
                this.clients = account_data.data
                this.totalRecords = account_data.total
            } else {
                this.clients = []
                this.totalRecords = 0
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке клиентов')
            }
            this.loading = false
        },
        async LoadUsers() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' })
            const account_data = await this.connect.GetAdminUsers().then(res=>res)
            if(account_data.result) {
                this.users = account_data.data
                this.totalRecords = account_data.total
            } else {
                this.users = []
                this.totalRecords = 0
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке пользователей')
            }
            this.loading = false
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.lazyParams.filters = this.filters
        this.LoadClients()
        this.LoadUsers()
    },
}
</script>